/* global Swiper */

document.addEventListener("DOMContentLoaded", () => {
    const thumbsProductGalleryClass = ".js-thumbs-product-gallery";
    const productGalleryClass = ".js-product-gallery";

    let thumbsGalleryElement = document.querySelector(thumbsProductGalleryClass);
    let productGalleryElement = document.querySelector(productGalleryClass);

    if (!thumbsGalleryElement || !productGalleryElement) {
        return;
    }

    const thumbsProductGallery = new Swiper(thumbsProductGalleryClass, {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });
    new Swiper(productGalleryClass, {
        loop: true,
        spaceBetween: 16,
        thumbs: {
            swiper: thumbsProductGallery,
        },
        navigation: {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev",
        },
    });
});
